// Centralized API configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000'
export const WS_URL = import.meta.env.VITE_WS_URL || 'http://localhost:3000'

// Helper to build API URLs
export const apiUrl = (path: string) => `${API_BASE_URL}${path}`
